/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["pagi", "pagi", "tengah hari", "petang", "malam"], u, ["tengah malam", "pagi", "tengah hari", "petang", "malam"]], [["pagi", "pagi", "tengah hari", "petang", "malam"], ["tengah malam", "pagi", "tengah hari", "petang", "malam"], u], [["00:00", "01:00"], ["01:00", "12:00"], ["12:00", "14:00"], ["14:00", "19:00"], ["19:00", "24:00"]]];
